<script setup lang="ts">
interface Props {
    title: string;
    value: string;
}

const props = defineProps<Props>();
</script>

<template>
    <div class="container rounded-corners stack">
        <div class="font-light"> {{ props.title }}</div>
        <div class="font-heavy"> {{ props.value }}</div>
    </div>
</template>

<style scoped>
.container {
    background-color: var(--color-primary);
    margin-bottom: 20px;
    color: white;
    font-family: Roboto, Arial, sans-serif;
    font-weight: 500;
    font-size: 24px;
    letter-spacing: 0%;
}

@media screen and (width <= 993px) {
    .container {
        min-width: 100%;
    }
}

.font-light {
    line-height: 33px;
    font-weight: 500;
    margin-top: 16px;
    margin-bottom: 16px;
}

.font-heavy {
    font-weight: 700;
    font-style: normal;
    line-height: 48px;
    margin-bottom: 16px;
}

.stack {
    flex-direction: column;
    align-items: center;
}
</style>
